import axios from 'axios';
import { message } from 'antd';
// 创建 axios 实例
const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE, // 本地开发走 Vite 代理，生产环境可用环境变量切换
  timeout: 10000,
});

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 例如：自动携带 token
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      config.headers['access-token'] = authToken;
    }
    // 其他自定义逻辑
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
http.interceptors.response.use(
  response => {
    // 统一处理响应数据
    const res = response.data;
    // status: 1成功，0失败，-1未登录
    if (res.status === 1) {
      return res;
    } else if (res.status === -1) {
      if (res.info) message.error(res.info);
      localStorage.removeItem('userInfo');
      localStorage.removeItem('authToken');
      // window.location.href = '/';
      return res;
    } else {
      return res;
    }
  },
  error => {
    // 统一处理错误
    if (error.response) {
      if (error.response.status === 401) {
        // 可以跳转登录页或弹窗
      }
      message.error(error.response.data?.message || '请求出错');
    } else {
      message.error('网络错误');
    }
    return Promise.reject(error);
  }
);

export default http;